import axios from 'axios';
import { store } from '../store/store';
import { logout } from '../store/authSlice';
import { adminLogout } from '../store/adminSlice';
import { showToast } from '../store/uiSlice';

const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:3000/api/v1';

const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor - add token
api.interceptors.request.use(
  (config) => {
    const state = store.getState();
    const token = state.auth?.token;
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Response interceptor - handle errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Check if it's an admin route
      const url = error.config?.url || '';
      if (url.includes('/admin/')) {
        store.dispatch(adminLogout());
        if (window.location.pathname !== '/admin/login') {
          window.location.href = '/admin/login';
        }
      } else {
        store.dispatch(logout());
        if (!window.location.pathname.includes('/login')) {
          window.location.href = '/login';
        }
      }
      store.dispatch(showToast({ message: 'Session expired. Please login again.', type: 'error' }));
    }
    return Promise.reject(error);
  }
);

// Admin API instance (separate for clarity)
export const adminApi = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

adminApi.interceptors.request.use((config) => {
  const state = store.getState();
  const token = state.admin?.adminToken;
  
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  } else {
    // If no token but trying to access admin routes, redirect to login
    if (config.url && config.url.includes('/admin')) {
      console.warn('No admin token found for admin route');
    }
  }
  
  return config;
});

adminApi.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      console.warn('Admin auth failed - token invalid or expired');
      store.dispatch(adminLogout());
      if (window.location.pathname !== '/admin/login') {
        window.location.href = '/admin/login';
      }
      store.dispatch(showToast({ message: 'Admin session expired', type: 'error' }));
    } else if (error.response?.status === 403) {
      store.dispatch(showToast({ message: 'Access denied', type: 'error' }));
    }
    return Promise.reject(error);
  }
);

export default api;